// ../companies/AddNewCompanyModalContent.js
import React, { useState } from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
// import { CssTextField } from '../../components/TextField'; // Adjust path
import { toast } from 'react-toastify';
import { CssTextField } from '../../components/TextField';
import { addNewCompany } from '../../store/actions/companiesActions';
// import { addNewCompany } from '../../store/actions'; // You need to create this action

const AddNewCompanyModalContent = ({ dispatch, setModal, setCompany, isLoading, colors }) => {
    const [values, setValues] = useState({
        name: "",
        email: "",
        mobile: "",
        address: "",
        gst_number: "" // Optional: Add fields relevant to a company
    });

    const handleChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (!values.name) return toast.error("Company Name is required");
        
        // Dispatch action to add company
        // Assuming your action returns the new ID or object on success
        const res = await dispatch(addNewCompany(values)); 
        
        if (res) {
            setCompany(res._id); // Auto-select the new company
            setModal(false);
            // toast.success("Company added successfully"); // Handled usually in action
        }
    };

    return (
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: colors.primary[400],
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: 2
            }}
        >
            <Typography variant="h4" mb={2}>Add New Company</Typography>
            <Stack spacing={2}>
                <CssTextField
                    label="Company Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                />
                <CssTextField
                    label="Email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                />
                <CssTextField
                    label="Mobile"
                    name="mobile"
                    value={values.mobile}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                />
                <CssTextField
                    label="Address"
                    name="address"
                    value={values.address}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    multiline
                    rows={2}
                />
                 <CssTextField
                    label="GST / Tax ID"
                    name="gst_number"
                    value={values.gst_number}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                />
                <Button 
                    variant="contained" 
                    onClick={handleSubmit} 
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress size={24} /> : "Add Company"}
                </Button>
            </Stack>
        </Box>
    );
};

export default AddNewCompanyModalContent;